// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"d764f0e2","15":"7311ff97","57":"e24b8885","453":"5f8dabab","514":"3c2b9446","768":"5efe7378","922":"8cb04c6d"}[chunkId] + ".chunk.js";
};